import React from "react";
import PageTemplate from "../../componentes/PageTemplate";

export default function Courses() {
    return(
        <PageTemplate>
                <h3>Meus cursos de aperfeiçoamento</h3>
        </PageTemplate>
    )
}